/* eslint-disable no-nested-ternary */
/* eslint-disable react/no-array-index-key */
/* eslint-disable react/jsx-props-no-spreading */
import React, { useState, useEffect } from "react";
import {
  PopUp,
  TermsAndConditionsWindow,
  GrowLanding,
} from "@pushpress/shared-components";
import Dashboard from "../../../layouts/Dashboard";
import {
  fetchApps,
  fetchInstalledApps,
  installApp,
  uninstallApp,
} from "../../../redux/actions/appActions";
import { getClient, isUserSuperuser } from "../../../utils/session";
import { createNewChatWithPrePopulatedMessage } from "../../../utils/Intercom";

const customStyles = {
  overlay: {
    width: "100%",
  },
  content: {
    width: "25%",
    height: "60%",
    margin: "auto",
  },
};

export default (props) => {
  const [growInstalled, setGrowInstalled] = useState();
  const [growAppId, setGrowAppId] = useState();
  const [growInstalllId, setGrowInstalllId] = useState();
  const [isOpen, setIsOpen] = useState(false);

  const clientId = props.client ? props.client.uuid : getClient.client_uuid;

  const checkInstalledApps = async () => {
    const apps = await fetchApps();
    const growId = apps.data.find((app) => app.name === "Grow by PushPress").id;
    const installedApps = await fetchInstalledApps(clientId);
    const growInstall = installedApps.data.find(
      (installedApp) => installedApp.appId === growId,
    );

    setGrowAppId(growId);
    setGrowInstalled(growInstall !== undefined);
    setGrowInstalllId(growInstall === undefined ? null : growInstall.id);
    return growInstall !== undefined;
  };

  const handleInstallApp = async () => {
    await installApp(clientId, growAppId, () => {
      window.location.reload();
    });
  };

  const handleUninstallApp = async () => {
    if (isUserSuperuser(props.user)) {
      await uninstallApp(clientId, growInstalllId, () => {
        window.location.href = "/";
      });
    } else {
      createNewChatWithPrePopulatedMessage("intercom.deactivateGrow");
    }
  };

  const onCancel = () => {
    setIsOpen(false);
  };

  const handleClick = () => {
    setIsOpen(true);
  };

  useEffect(() => {
    const checkGrowInstalled = async () => {
      await checkInstalledApps();
    };
    checkGrowInstalled();
  }, []);

  return (
    <>
      <Dashboard>
        <PopUp
          customStyles={customStyles}
          isOpen={isOpen}
          setIsOpen={setIsOpen}
        >
          <TermsAndConditionsWindow
            onClickCancel={onCancel}
            onClickOk={handleInstallApp}
            link="https://www.pushpress.com/legal/grow-service-agreement"
            terms="We aim to have your Grow setup complete within 10 business days. \n\nWhen signing up for Grow, you will see the associated fees: \n # $699 one-time setup fee (billed today) \n # $299 monthly subscription fee (billed in 7 days)"
            title="Let's Grow"
            okText="signUp"
            widthOkayText="4.5em"
          />
        </PopUp>
        <div className="app-configuration-grid">
          <GrowLanding
            onClickInstall={handleClick}
            onClickUninstall={handleUninstallApp}
            isInstalled={growInstalled}
            prices={{ price: 299, setupFee: 699 }}
            imageProperties={{
              url: `https://assets.cdn.pushpress.com/dashboard/imageGrowLandingBlueContainer.png`,
            }}
          />
        </div>
      </Dashboard>
    </>
  );
};
